import * as React$1 from 'react';
import React__default, { useEffect, useState, useRef, useCallback } from 'react';
import require$$1, { createPortal } from 'react-dom';

function getAugmentedNamespace(n) {
  var f = n.default;
	if (typeof f == "function") {
		var a = function () {
			return f.apply(this, arguments);
		};
		a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var classnames$1 = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
} (classnames$1));

var classnames = classnames$1.exports;

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;
	(function (module) {

		if (process.env.NODE_ENV === 'production') {
		  module.exports = requireReactIs_production_min();
		} else {
		  module.exports = requireReactIs_development();
		}
} (reactIs));
	return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has;
	hasRequiredHas = 1;
	has = Function.call.bind(Object.prototype.hasOwnProperty);
	return has;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var candidateSelectors = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]:not(slot)', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])', 'details>summary:first-of-type', 'details'];
var candidateSelector = /* #__PURE__ */candidateSelectors.join(',');
var NoElement = typeof Element === 'undefined';
var matches = NoElement ? function () {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function (element) {
  return element.getRootNode();
} : function (element) {
  return element.ownerDocument;
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */

var getCandidates = function getCandidates(el, includeContainer, filter) {
  var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));

  if (includeContainer && matches.call(el, candidateSelector)) {
    candidates.unshift(el);
  }

  candidates = candidates.filter(filter);
  return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */

/**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */

/**
 * @typedef {Object} CandidatesScope
 * @property {Element} scope contains inner candidates
 * @property {Element[]} candidates
 */

/**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidatesScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */

/**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidatesScope>}
 */


var getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
  var candidates = [];
  var elementsToCheck = Array.from(elements);

  while (elementsToCheck.length) {
    var element = elementsToCheck.shift();

    if (element.tagName === 'SLOT') {
      // add shadow dom slot scope (slot itself cannot be focusable)
      var assigned = element.assignedElements();
      var content = assigned.length ? assigned : element.children;
      var nestedCandidates = getCandidatesIteratively(content, true, options);

      if (options.flatten) {
        candidates.push.apply(candidates, nestedCandidates);
      } else {
        candidates.push({
          scope: element,
          candidates: nestedCandidates
        });
      }
    } else {
      // check candidate element
      var validCandidate = matches.call(element, candidateSelector);

      if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) {
        candidates.push(element);
      } // iterate over shadow content if possible


      var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
      typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
      var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);

      if (shadowRoot && validShadowRoot) {
        // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
        //  shadow exists, so look at light dom children as fallback BUT create a scope for any
        //  child candidates found because they're likely slotted elements (elements that are
        //  children of the web component element (which has the shadow), in the light dom, but
        //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
        //  _after_ we return from this recursive call
        var _nestedCandidates = getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);

        if (options.flatten) {
          candidates.push.apply(candidates, _nestedCandidates);
        } else {
          candidates.push({
            scope: element,
            candidates: _nestedCandidates
          });
        }
      } else {
        // there's not shadow so just dig into the element's (light dom) children
        //  __without__ giving the element special scope treatment
        elementsToCheck.unshift.apply(elementsToCheck, element.children);
      }
    }
  }

  return candidates;
};

var getTabindex = function getTabindex(node, isScope) {
  if (node.tabIndex < 0) {
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    // yet they are still part of the regular tab order; in FF, they get a default
    // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    // order, consider their tab index to be 0.
    // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    //
    // isScope is positive for custom element with shadow root or slot that by default
    // have tabIndex -1, but need to be sorted by document order in order for their
    // content to be inserted in the correct position
    if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute('tabindex'), 10))) {
      return 0;
    }
  }

  return node.tabIndex;
};

var sortOrderedTabbables = function sortOrderedTabbables(a, b) {
  return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};

var isInput = function isInput(node) {
  return node.tagName === 'INPUT';
};

var isHiddenInput = function isHiddenInput(node) {
  return isInput(node) && node.type === 'hidden';
};

var isDetailsWithSummary = function isDetailsWithSummary(node) {
  var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function (child) {
    return child.tagName === 'SUMMARY';
  });
  return r;
};

var getCheckedRadio = function getCheckedRadio(nodes, form) {
  for (var i = 0; i < nodes.length; i++) {
    if (nodes[i].checked && nodes[i].form === form) {
      return nodes[i];
    }
  }
};

var isTabbableRadio = function isTabbableRadio(node) {
  if (!node.name) {
    return true;
  }

  var radioScope = node.form || getRootNode(node);

  var queryRadios = function queryRadios(name) {
    return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
  };

  var radioSet;

  if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') {
    radioSet = queryRadios(window.CSS.escape(node.name));
  } else {
    try {
      radioSet = queryRadios(node.name);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
      return false;
    }
  }

  var checked = getCheckedRadio(radioSet, node.form);
  return !checked || checked === node;
};

var isRadio = function isRadio(node) {
  return isInput(node) && node.type === 'radio';
};

var isNonTabbableRadio = function isNonTabbableRadio(node) {
  return isRadio(node) && !isTabbableRadio(node);
};

var isZeroArea = function isZeroArea(node) {
  var _node$getBoundingClie = node.getBoundingClientRect(),
      width = _node$getBoundingClie.width,
      height = _node$getBoundingClie.height;

  return width === 0 && height === 0;
};

var isHidden = function isHidden(node, _ref) {
  var displayCheck = _ref.displayCheck,
      getShadowRoot = _ref.getShadowRoot;

  // NOTE: visibility will be `undefined` if node is detached from the document
  //  (see notes about this further down), which means we will consider it visible
  //  (this is legacy behavior from a very long way back)
  // NOTE: we check this regardless of `displayCheck="none"` because this is a
  //  _visibility_ check, not a _display_ check
  if (getComputedStyle(node).visibility === 'hidden') {
    return true;
  }

  var isDirectSummary = matches.call(node, 'details>summary:first-of-type');
  var nodeUnderDetails = isDirectSummary ? node.parentElement : node;

  if (matches.call(nodeUnderDetails, 'details:not([open]) *')) {
    return true;
  } // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
  //  (but NOT _the_ document; see second 'If' comment below for more).
  // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
  //  is attached, and the one we need to check if it's in the document or not (because the
  //  shadow, and all nodes it contains, is never considered in the document since shadows
  //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
  //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
  //  visibility, including all the nodes it contains). The host could be any normal node,
  //  or a custom element (i.e. web component). Either way, that's the one that is considered
  //  part of the document, not the shadow root, nor any of its children (i.e. the node being
  //  tested).
  // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
  //  document (per the docs) and while it's a Document-type object, that document does not
  //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
  //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
  //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
  //  node is actually detached.


  var nodeRootHost = getRootNode(node).host;
  var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);

  if (!displayCheck || displayCheck === 'full') {
    if (typeof getShadowRoot === 'function') {
      // figure out if we should consider the node to be in an undisclosed shadow and use the
      //  'non-zero-area' fallback
      var originalNode = node;

      while (node) {
        var parentElement = node.parentElement;
        var rootNode = getRootNode(node);

        if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
        ) {
          // node has an undisclosed shadow which means we can only treat it as a black box, so we
          //  fall back to a non-zero-area test
          return isZeroArea(node);
        } else if (node.assignedSlot) {
          // iterate up slot
          node = node.assignedSlot;
        } else if (!parentElement && rootNode !== node.ownerDocument) {
          // cross shadow boundary
          node = rootNode.host;
        } else {
          // iterate up normal dom
          node = parentElement;
        }
      }

      node = originalNode;
    } // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
    //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
    //  it might be a falsy value, which means shadow DOM support is disabled
    // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
    //  now we can just test to see if it would normally be visible or not, provided it's
    //  attached to the main document.
    // NOTE: We must consider case where node is inside a shadow DOM and given directly to
    //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.


    if (nodeIsAttached) {
      // this works wherever the node is: if there's at least one client rect, it's
      //  somehow displayed; it also covers the CSS 'display: contents' case where the
      //  node itself is hidden in place of its contents; and there's no need to search
      //  up the hierarchy either
      return !node.getClientRects().length;
    } // Else, the node isn't attached to the document, which means the `getClientRects()`
    //  API will __always__ return zero rects (this can happen, for example, if React
    //  is used to render nodes onto a detached tree, as confirmed in this thread:
    //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
    //
    // It also means that even window.getComputedStyle(node).display will return `undefined`
    //  because styles are only computed for nodes that are in the document.
    //
    // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
    //  somehow. Though it was never stated officially, anyone who has ever used tabbable
    //  APIs on nodes in detached containers has actually implicitly used tabbable in what
    //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
    //  considering __everything__ to be visible because of the innability to determine styles.

  } else if (displayCheck === 'non-zero-area') {
    // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return isZeroArea(node);
  } // visible, as far as we can tell, or per current `displayCheck` mode


  return false;
}; // form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset


var isDisabledFromFieldset = function isDisabledFromFieldset(node) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
    var parentNode = node.parentElement; // check if `node` is contained in a disabled <fieldset>

    while (parentNode) {
      if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
        // look for the first <legend> among the children of the disabled <fieldset>
        for (var i = 0; i < parentNode.children.length; i++) {
          var child = parentNode.children.item(i); // when the first <legend> (in document order) is found

          if (child.tagName === 'LEGEND') {
            // if its parent <fieldset> is not nested in another disabled <fieldset>,
            // return whether `node` is a descendant of its first <legend>
            return matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
          }
        } // the disabled <fieldset> containing `node` has no <legend>


        return true;
      }

      parentNode = parentNode.parentElement;
    }
  } // else, node's tabbable/focusable state should not be affected by a fieldset's
  //  enabled/disabled state


  return false;
};

var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
  if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
  isDetailsWithSummary(node) || isDisabledFromFieldset(node)) {
    return false;
  }

  return true;
};

var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
  if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) {
    return false;
  }

  return true;
};

var isValidShadowRootTabbable = function isValidShadowRootTabbable(shadowHostNode) {
  var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);

  if (isNaN(tabIndex) || tabIndex >= 0) {
    return true;
  } // If a custom element has an explicit negative tabindex,
  // browsers will not allow tab targeting said element's children.


  return false;
};
/**
 * @param {Array.<Element|CandidatesScope>} candidates
 * @returns Element[]
 */


var sortByOrder = function sortByOrder(candidates) {
  var regularTabbables = [];
  var orderedTabbables = [];
  candidates.forEach(function (item, i) {
    var isScope = !!item.scope;
    var element = isScope ? item.scope : item;
    var candidateTabindex = getTabindex(element, isScope);
    var elements = isScope ? sortByOrder(item.candidates) : element;

    if (candidateTabindex === 0) {
      isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
    } else {
      orderedTabbables.push({
        documentOrder: i,
        tabIndex: candidateTabindex,
        item: item,
        isScope: isScope,
        content: elements
      });
    }
  });
  return orderedTabbables.sort(sortOrderedTabbables).reduce(function (acc, sortable) {
    sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
    return acc;
  }, []).concat(regularTabbables);
};

var tabbable = function tabbable(el, options) {
  options = options || {};
  var candidates;

  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorTabbable.bind(null, options),
      flatten: false,
      getShadowRoot: options.getShadowRoot,
      shadowRootFilter: isValidShadowRootTabbable
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
  }

  return sortByOrder(candidates);
};

var focusable = function focusable(el, options) {
  options = options || {};
  var candidates;

  if (options.getShadowRoot) {
    candidates = getCandidatesIteratively([el], options.includeContainer, {
      filter: isNodeMatchingSelectorFocusable.bind(null, options),
      flatten: true,
      getShadowRoot: options.getShadowRoot
    });
  } else {
    candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
  }

  return candidates;
};

var isTabbable = function isTabbable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, candidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorTabbable(options, node);
};

var focusableCandidateSelector = /* #__PURE__ */candidateSelectors.concat('iframe').join(',');

var isFocusable$1 = function isFocusable(node, options) {
  options = options || {};

  if (!node) {
    throw new Error('No node provided');
  }

  if (matches.call(node, focusableCandidateSelector) === false) {
    return false;
  }

  return isNodeMatchingSelectorFocusable(options, node);
};

var index_esm = /*#__PURE__*/Object.freeze({
	__proto__: null,
	focusable: focusable,
	isFocusable: isFocusable$1,
	isTabbable: isTabbable,
	tabbable: tabbable
});

/*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var activeFocusTraps = function () {
  var trapQueue = [];
  return {
    activateTrap: function activateTrap(trap) {
      if (trapQueue.length > 0) {
        var activeTrap = trapQueue[trapQueue.length - 1];

        if (activeTrap !== trap) {
          activeTrap.pause();
        }
      }

      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex === -1) {
        trapQueue.push(trap);
      } else {
        // move this existing trap to the front of the queue
        trapQueue.splice(trapIndex, 1);
        trapQueue.push(trap);
      }
    },
    deactivateTrap: function deactivateTrap(trap) {
      var trapIndex = trapQueue.indexOf(trap);

      if (trapIndex !== -1) {
        trapQueue.splice(trapIndex, 1);
      }

      if (trapQueue.length > 0) {
        trapQueue[trapQueue.length - 1].unpause();
      }
    }
  };
}();

var isSelectableInput = function isSelectableInput(node) {
  return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};

var isEscapeEvent = function isEscapeEvent(e) {
  return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
};

var isTabEvent = function isTabEvent(e) {
  return e.key === 'Tab' || e.keyCode === 9;
};

var delay = function delay(fn) {
  return setTimeout(fn, 0);
}; // Array.find/findIndex() are not supported on IE; this replicates enough
//  of Array.findIndex() for our needs


var findIndex = function findIndex(arr, fn) {
  var idx = -1;
  arr.every(function (value, i) {
    if (fn(value)) {
      idx = i;
      return false; // break
    }

    return true; // next
  });
  return idx;
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */


var valueOrHandler = function valueOrHandler(value) {
  for (var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    params[_key - 1] = arguments[_key];
  }

  return typeof value === 'function' ? value.apply(void 0, params) : value;
};

var getActualTarget = function getActualTarget(event) {
  // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
  //  shadow host. However, event.target.composedPath() will be an array of
  //  nodes "clicked" from inner-most (the actual element inside the shadow) to
  //  outer-most (the host HTML document). If we have access to composedPath(),
  //  then use its first element; otherwise, fall back to event.target (and
  //  this only works for an _open_ shadow DOM; otherwise,
  //  composedPath()[0] === event.target always).
  return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};

var createFocusTrap$1 = function createFocusTrap(elements, userOptions) {
  // SSR: a live trap shouldn't be created in this type of environment so this
  //  should be safe code to execute if the `document` option isn't specified
  var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;

  var config = _objectSpread2({
    returnFocusOnDeactivate: true,
    escapeDeactivates: true,
    delayInitialFocus: true
  }, userOptions);

  var state = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: false,
    paused: false,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: undefined
  };
  var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later

  /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */

  var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
    return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
  };
  /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */


  var findContainerIndex = function findContainerIndex(element) {
    // NOTE: search `containerGroups` because it's possible a group contains no tabbable
    //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
    //  and we still need to find the element in there
    return state.containerGroups.findIndex(function (_ref) {
      var container = _ref.container,
          tabbableNodes = _ref.tabbableNodes;
      return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      tabbableNodes.find(function (node) {
        return node === element;
      });
    });
  };
  /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @returns {undefined | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `false` if the option
   *  resolved to `false` (node explicitly not given); otherwise, the resolved
   *  DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node.
   */


  var getNodeForOption = function getNodeForOption(optionName) {
    var optionValue = config[optionName];

    if (typeof optionValue === 'function') {
      for (var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        params[_key2 - 1] = arguments[_key2];
      }

      optionValue = optionValue.apply(void 0, params);
    }

    if (optionValue === true) {
      optionValue = undefined; // use default value
    }

    if (!optionValue) {
      if (optionValue === undefined || optionValue === false) {
        return optionValue;
      } // else, empty string (invalid), null (invalid), 0 (invalid)


      throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
    }

    var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point

    if (typeof optionValue === 'string') {
      node = doc.querySelector(optionValue); // resolve to node, or null if fails

      if (!node) {
        throw new Error("`".concat(optionName, "` as selector refers to no known node"));
      }
    }

    return node;
  };

  var getInitialFocusNode = function getInitialFocusNode() {
    var node = getNodeForOption('initialFocus'); // false explicitly indicates we want no initialFocus at all

    if (node === false) {
      return false;
    }

    if (node === undefined) {
      // option not specified: use fallback options
      if (findContainerIndex(doc.activeElement) >= 0) {
        node = doc.activeElement;
      } else {
        var firstTabbableGroup = state.tabbableGroups[0];
        var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode; // NOTE: `fallbackFocus` option function cannot return `false` (not supported)

        node = firstTabbableNode || getNodeForOption('fallbackFocus');
      }
    }

    if (!node) {
      throw new Error('Your focus-trap needs to have at least one focusable element');
    }

    return node;
  };

  var updateTabbableNodes = function updateTabbableNodes() {
    state.containerGroups = state.containers.map(function (container) {
      var tabbableNodes = tabbable(container, config.tabbableOptions); // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
      //  are a superset of tabbable nodes

      var focusableNodes = focusable(container, config.tabbableOptions);
      return {
        container: container,
        tabbableNodes: tabbableNodes,
        focusableNodes: focusableNodes,
        firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
        lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,

        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function nextTabbableNode(node) {
          var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
          // NOTE: If tabindex is positive (in order to manipulate the tab order separate
          //  from the DOM order), this __will not work__ because the list of focusableNodes,
          //  while it contains tabbable nodes, does not sort its nodes in any order other
          //  than DOM order, because it can't: Where would you place focusable (but not
          //  tabbable) nodes in that order? They have no order, because they aren't tabbale...
          // Support for positive tabindex is already broken and hard to manage (possibly
          //  not supportable, TBD), so this isn't going to make things worse than they
          //  already are, and at least makes things better for the majority of cases where
          //  tabindex is either 0/unset or negative.
          // FYI, positive tabindex issue: https://github.com/focus-trap/focus-trap/issues/375
          var nodeIdx = focusableNodes.findIndex(function (n) {
            return n === node;
          });

          if (nodeIdx < 0) {
            return undefined;
          }

          if (forward) {
            return focusableNodes.slice(nodeIdx + 1).find(function (n) {
              return isTabbable(n, config.tabbableOptions);
            });
          }

          return focusableNodes.slice(0, nodeIdx).reverse().find(function (n) {
            return isTabbable(n, config.tabbableOptions);
          });
        }
      };
    });
    state.tabbableGroups = state.containerGroups.filter(function (group) {
      return group.tabbableNodes.length > 0;
    }); // throw if no groups have tabbable nodes and we don't have a fallback focus node either

    if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
    ) {
      throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
    }
  };

  var tryFocus = function tryFocus(node) {
    if (node === false) {
      return;
    }

    if (node === doc.activeElement) {
      return;
    }

    if (!node || !node.focus) {
      tryFocus(getInitialFocusNode());
      return;
    }

    node.focus({
      preventScroll: !!config.preventScroll
    });
    state.mostRecentlyFocusedNode = node;

    if (isSelectableInput(node)) {
      node.select();
    }
  };

  var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
    var node = getNodeForOption('setReturnFocus', previousActiveElement);
    return node ? node : node === false ? false : previousActiveElement;
  }; // This needs to be done on mousedown and touchstart instead of click
  // so that it precedes the focus event.


  var checkPointerDown = function checkPointerDown(e) {
    var target = getActualTarget(e);

    if (findContainerIndex(target) >= 0) {
      // allow the click since it ocurred inside the trap
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      // immediately deactivate the trap
      trap.deactivate({
        // if, on deactivation, we should return focus to the node originally-focused
        //  when the trap was activated (or the configured `setReturnFocus` node),
        //  then assume it's also OK to return focus to the outside node that was
        //  just clicked, causing deactivation, as long as that node is focusable;
        //  if it isn't focusable, then return focus to the original node focused
        //  on activation (or the configured `setReturnFocus` node)
        // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
        //  which will result in the outside click setting focus to the node
        //  that was clicked, whether it's focusable or not; by setting
        //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
        //  on activation (or the configured `setReturnFocus` node)
        returnFocus: config.returnFocusOnDeactivate && !isFocusable$1(target, config.tabbableOptions)
      });
      return;
    } // This is needed for mobile devices.
    // (If we'll only let `click` events through,
    // then on mobile they will be blocked anyways if `touchstart` is blocked.)


    if (valueOrHandler(config.allowOutsideClick, e)) {
      // allow the click outside the trap to take place
      return;
    } // otherwise, prevent the click


    e.preventDefault();
  }; // In case focus escapes the trap for some strange reason, pull it back in.


  var checkFocusIn = function checkFocusIn(e) {
    var target = getActualTarget(e);
    var targetContained = findContainerIndex(target) >= 0; // In Firefox when you Tab out of an iframe the Document is briefly focused.

    if (targetContained || target instanceof Document) {
      if (targetContained) {
        state.mostRecentlyFocusedNode = target;
      }
    } else {
      // escaped! pull it back in to where it just left
      e.stopImmediatePropagation();
      tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
    }
  }; // Hijack Tab events on the first and last focusable nodes of the trap,
  // in order to prevent focus from escaping. If it escapes for even a
  // moment it can end up scrolling the page and causing confusion so we
  // kind of need to capture the action at the keydown phase.


  var checkTab = function checkTab(e) {
    var target = getActualTarget(e);
    updateTabbableNodes();
    var destinationNode = null;

    if (state.tabbableGroups.length > 0) {
      // make sure the target is actually contained in a group
      // NOTE: the target may also be the container itself if it's focusable
      //  with tabIndex='-1' and was given initial focus
      var containerIndex = findContainerIndex(target);
      var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;

      if (containerIndex < 0) {
        // target not found in any group: quite possible focus has escaped the trap,
        //  so bring it back in to...
        if (e.shiftKey) {
          // ...the last node in the last group
          destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
        } else {
          // ...the first node in the first group
          destinationNode = state.tabbableGroups[0].firstTabbableNode;
        }
      } else if (e.shiftKey) {
        // REVERSE
        // is the target the first tabbable node in a group?
        var startOfGroupIndex = findIndex(state.tabbableGroups, function (_ref2) {
          var firstTabbableNode = _ref2.firstTabbableNode;
          return target === firstTabbableNode;
        });

        if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable$1(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) {
          // an exception case where the target is either the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle shift+tab as if focus were on the container's
          //  first tabbable node, and go to the last tabbable node of the LAST group
          startOfGroupIndex = containerIndex;
        }

        if (startOfGroupIndex >= 0) {
          // YES: then shift+tab should go to the last tabbable node in the
          //  previous group (and wrap around to the last tabbable node of
          //  the LAST group if it's the first tabbable node of the FIRST group)
          var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
          var destinationGroup = state.tabbableGroups[destinationGroupIndex];
          destinationNode = destinationGroup.lastTabbableNode;
        }
      } else {
        // FORWARD
        // is the target the last tabbable node in a group?
        var lastOfGroupIndex = findIndex(state.tabbableGroups, function (_ref3) {
          var lastTabbableNode = _ref3.lastTabbableNode;
          return target === lastTabbableNode;
        });

        if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable$1(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) {
          // an exception case where the target is the container itself, or
          //  a non-tabbable node that was given focus (i.e. tabindex is negative
          //  and user clicked on it or node was programmatically given focus)
          //  and is not followed by any other tabbable node, in which
          //  case, we should handle tab as if focus were on the container's
          //  last tabbable node, and go to the first tabbable node of the FIRST group
          lastOfGroupIndex = containerIndex;
        }

        if (lastOfGroupIndex >= 0) {
          // YES: then tab should go to the first tabbable node in the next
          //  group (and wrap around to the first tabbable node of the FIRST
          //  group if it's the last tabbable node of the LAST group)
          var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;

          var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
          destinationNode = _destinationGroup.firstTabbableNode;
        }
      }
    } else {
      // NOTE: the fallbackFocus option does not support returning false to opt-out
      destinationNode = getNodeForOption('fallbackFocus');
    }

    if (destinationNode) {
      e.preventDefault();
      tryFocus(destinationNode);
    } // else, let the browser take care of [shift+]tab and move the focus

  };

  var checkKey = function checkKey(e) {
    if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
      e.preventDefault();
      trap.deactivate();
      return;
    }

    if (isTabEvent(e)) {
      checkTab(e);
      return;
    }
  };

  var checkClick = function checkClick(e) {
    var target = getActualTarget(e);

    if (findContainerIndex(target) >= 0) {
      return;
    }

    if (valueOrHandler(config.clickOutsideDeactivates, e)) {
      return;
    }

    if (valueOrHandler(config.allowOutsideClick, e)) {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();
  }; //
  // EVENT LISTENERS
  //


  var addListeners = function addListeners() {
    if (!state.active) {
      return;
    } // There can be only one listening focus trap at a time


    activeFocusTraps.activateTrap(trap); // Delay ensures that the focused element doesn't capture the event
    // that caused the focus trap activation.

    state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function () {
      tryFocus(getInitialFocusNode());
    }) : tryFocus(getInitialFocusNode());
    doc.addEventListener('focusin', checkFocusIn, true);
    doc.addEventListener('mousedown', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('touchstart', checkPointerDown, {
      capture: true,
      passive: false
    });
    doc.addEventListener('click', checkClick, {
      capture: true,
      passive: false
    });
    doc.addEventListener('keydown', checkKey, {
      capture: true,
      passive: false
    });
    return trap;
  };

  var removeListeners = function removeListeners() {
    if (!state.active) {
      return;
    }

    doc.removeEventListener('focusin', checkFocusIn, true);
    doc.removeEventListener('mousedown', checkPointerDown, true);
    doc.removeEventListener('touchstart', checkPointerDown, true);
    doc.removeEventListener('click', checkClick, true);
    doc.removeEventListener('keydown', checkKey, true);
    return trap;
  }; //
  // TRAP DEFINITION
  //


  trap = {
    get active() {
      return state.active;
    },

    get paused() {
      return state.paused;
    },

    activate: function activate(activateOptions) {
      if (state.active) {
        return this;
      }

      var onActivate = getOption(activateOptions, 'onActivate');
      var onPostActivate = getOption(activateOptions, 'onPostActivate');
      var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');

      if (!checkCanFocusTrap) {
        updateTabbableNodes();
      }

      state.active = true;
      state.paused = false;
      state.nodeFocusedBeforeActivation = doc.activeElement;

      if (onActivate) {
        onActivate();
      }

      var finishActivation = function finishActivation() {
        if (checkCanFocusTrap) {
          updateTabbableNodes();
        }

        addListeners();

        if (onPostActivate) {
          onPostActivate();
        }
      };

      if (checkCanFocusTrap) {
        checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
        return this;
      }

      finishActivation();
      return this;
    },
    deactivate: function deactivate(deactivateOptions) {
      if (!state.active) {
        return this;
      }

      var options = _objectSpread2({
        onDeactivate: config.onDeactivate,
        onPostDeactivate: config.onPostDeactivate,
        checkCanReturnFocus: config.checkCanReturnFocus
      }, deactivateOptions);

      clearTimeout(state.delayInitialFocusTimer); // noop if undefined

      state.delayInitialFocusTimer = undefined;
      removeListeners();
      state.active = false;
      state.paused = false;
      activeFocusTraps.deactivateTrap(trap);
      var onDeactivate = getOption(options, 'onDeactivate');
      var onPostDeactivate = getOption(options, 'onPostDeactivate');
      var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
      var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');

      if (onDeactivate) {
        onDeactivate();
      }

      var finishDeactivation = function finishDeactivation() {
        delay(function () {
          if (returnFocus) {
            tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
          }

          if (onPostDeactivate) {
            onPostDeactivate();
          }
        });
      };

      if (returnFocus && checkCanReturnFocus) {
        checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
        return this;
      }

      finishDeactivation();
      return this;
    },
    pause: function pause() {
      if (state.paused || !state.active) {
        return this;
      }

      state.paused = true;
      removeListeners();
      return this;
    },
    unpause: function unpause() {
      if (!state.paused || !state.active) {
        return this;
      }

      state.paused = false;
      updateTabbableNodes();
      addListeners();
      return this;
    },
    updateContainerElements: function updateContainerElements(containerElements) {
      var elementsAsArray = [].concat(containerElements).filter(Boolean);
      state.containers = elementsAsArray.map(function (element) {
        return typeof element === 'string' ? doc.querySelector(element) : element;
      });

      if (state.active) {
        updateTabbableNodes();
      }

      return this;
    }
  }; // initialize container elements

  trap.updateContainerElements(elements);
  return trap;
};

var focusTrap_esm = /*#__PURE__*/Object.freeze({
	__proto__: null,
	createFocusTrap: createFocusTrap$1
});

var require$$3 = /*@__PURE__*/getAugmentedNamespace(focusTrap_esm);

var require$$4 = /*@__PURE__*/getAugmentedNamespace(index_esm);

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var React = React__default;

var ReactDOM = require$$1;

var PropTypes = propTypes.exports;

var _require = require$$3,
    createFocusTrap = _require.createFocusTrap;

var _require2 = require$$4,
    isFocusable = _require2.isFocusable; // TODO: These issues are related to older React features which we'll likely need
//  to fix in order to move the code forward to the next major version of React.
//  @see https://github.com/davidtheclark/focus-trap-react/issues/77

/* eslint-disable react/no-find-dom-node */


var FocusTrap = /*#__PURE__*/function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  var _super = _createSuper(FocusTrap);

  function FocusTrap(props) {
    var _this;

    _classCallCheck(this, FocusTrap);

    _this = _super.call(this, props);
    _this.handleDeactivate = _this.handleDeactivate.bind(_assertThisInitialized(_this));
    _this.handlePostDeactivate = _this.handlePostDeactivate.bind(_assertThisInitialized(_this));
    _this.handleClickOutsideDeactivates = _this.handleClickOutsideDeactivates.bind(_assertThisInitialized(_this)); // focus-trap options used internally when creating the trap

    _this.internalOptions = {
      // We need to hijack the returnFocusOnDeactivate option,
      // because React can move focus into the element before we arrived at
      // this lifecycle hook (e.g. with autoFocus inputs). So the component
      // captures the previouslyFocusedElement in componentWillMount,
      // then (optionally) returns focus to it in componentWillUnmount.
      returnFocusOnDeactivate: false,
      // the rest of these are also related to deactivation of the trap, and we
      //  need to use them and control them as well
      checkCanReturnFocus: null,
      onDeactivate: _this.handleDeactivate,
      onPostDeactivate: _this.handlePostDeactivate,
      // we need to special-case this setting as well so that we can know if we should
      //  NOT return focus if the trap gets auto-deactivated as the result of an
      //  outside click (otherwise, we'll always think we should return focus because
      //  of how we manage that flag internally here)
      clickOutsideDeactivates: _this.handleClickOutsideDeactivates
    }; // original options provided by the consumer

    _this.originalOptions = {
      // because of the above `tailoredFocusTrapOptions`, we maintain our own flag for
      //  this option, and default it to `true` because that's focus-trap's default
      returnFocusOnDeactivate: true,
      // because of the above `tailoredFocusTrapOptions`, we keep these separate since
      //  they're part of the deactivation process which we configure (internally) to
      //  be shared between focus-trap and focus-trap-react
      onDeactivate: null,
      onPostDeactivate: null,
      checkCanReturnFocus: null,
      // the user's setting, defaulted to false since focus-trap defaults this to false
      clickOutsideDeactivates: false
    };
    var focusTrapOptions = props.focusTrapOptions;

    for (var optionName in focusTrapOptions) {
      if (!Object.prototype.hasOwnProperty.call(focusTrapOptions, optionName)) {
        continue;
      }

      if (optionName === 'returnFocusOnDeactivate' || optionName === 'onDeactivate' || optionName === 'onPostDeactivate' || optionName === 'checkCanReturnFocus' || optionName === 'clickOutsideDeactivates') {
        _this.originalOptions[optionName] = focusTrapOptions[optionName];
        continue; // exclude from tailoredFocusTrapOptions
      }

      _this.internalOptions[optionName] = focusTrapOptions[optionName];
    } // if set, `{ target: Node, allowDeactivation: boolean }` where `target` is the outside
    //  node that was clicked, and `allowDeactivation` is the result of the consumer's
    //  option (stored in `this.originalOptions.clickOutsideDeactivates`, which may be a
    //  function) whether to allow or deny auto-deactivation on click on this outside node


    _this.outsideClick = null; // elements from which to create the focus trap on mount; if a child is used
    //  instead of the `containerElements` prop, we'll get the child's related
    //  element when the trap renders and then is declared 'mounted'

    _this.focusTrapElements = props.containerElements || []; // now we remember what the currently focused element is, not relying on focus-trap

    _this.updatePreviousElement();

    return _this;
  }
  /**
   * Gets the configured document.
   * @returns {Document|undefined} Configured document, falling back to the main
   *  document, if it exists. During SSR, `undefined` is returned since the
   *  document doesn't exist.
   */


  _createClass(FocusTrap, [{
    key: "getDocument",
    value: function getDocument() {
      // SSR: careful to check if `document` exists before accessing it as a variable
      return this.props.focusTrapOptions.document || (typeof document !== 'undefined' ? document : undefined);
    } // TODO: Need more test coverage for this function

  }, {
    key: "getNodeForOption",
    value: function getNodeForOption(optionName) {
      var optionValue = this.internalOptions[optionName];

      if (!optionValue) {
        return null;
      }

      var node = optionValue;

      if (typeof optionValue === 'string') {
        var _this$getDocument;

        node = (_this$getDocument = this.getDocument()) === null || _this$getDocument === void 0 ? void 0 : _this$getDocument.querySelector(optionValue);

        if (!node) {
          throw new Error("`".concat(optionName, "` refers to no known node"));
        }
      }

      if (typeof optionValue === 'function') {
        node = optionValue();

        if (!node) {
          throw new Error("`".concat(optionName, "` did not return a node"));
        }
      }

      return node;
    }
  }, {
    key: "getReturnFocusNode",
    value: function getReturnFocusNode() {
      var node = this.getNodeForOption('setReturnFocus');
      return node ? node : this.previouslyFocusedElement;
    }
    /** Update the previously focused element with the currently focused element. */

  }, {
    key: "updatePreviousElement",
    value: function updatePreviousElement() {
      var currentDocument = this.getDocument();

      if (currentDocument) {
        this.previouslyFocusedElement = currentDocument.activeElement;
      }
    }
  }, {
    key: "deactivateTrap",
    value: function deactivateTrap() {
      // NOTE: it's possible the focus trap has already been deactivated without our knowing it,
      //  especially if the user set the `clickOutsideDeactivates: true` option on the trap,
      //  and the mouse was clicked on some element outside the trap; at that point, focus-trap
      //  will initiate its auto-deactivation process, which will call our own
      //  handleDeactivate(), which will call into this method
      if (!this.focusTrap || !this.focusTrap.active) {
        return;
      }

      this.focusTrap.deactivate({
        // NOTE: we never let the trap return the focus since we do that ourselves
        returnFocus: false,
        // we'll call this in our own post deactivate handler so make sure the trap doesn't
        //  do it prematurely
        checkCanReturnFocus: null,
        // let it call the user's original deactivate handler, if any, instead of
        //  our own which calls back into this function
        onDeactivate: this.originalOptions.onDeactivate // NOTE: for post deactivate, don't specify anything so that it calls the
        //  onPostDeactivate handler specified on `this.internalOptions`
        //  which will always be our own `handlePostDeactivate()` handler, which
        //  will finish things off by calling the user's provided onPostDeactivate
        //  handler, if any, at the right time
        // onPostDeactivate: NOTHING

      });
    }
  }, {
    key: "handleClickOutsideDeactivates",
    value: function handleClickOutsideDeactivates(event) {
      // use consumer's option (or call their handler) as the permission or denial
      var allowDeactivation = typeof this.originalOptions.clickOutsideDeactivates === 'function' ? this.originalOptions.clickOutsideDeactivates.call(null, event) // call out of context
      : this.originalOptions.clickOutsideDeactivates; // boolean

      if (allowDeactivation) {
        // capture the outside target that was clicked so we can use it in the deactivation
        //  process since the consumer allowed it to cause auto-deactivation
        this.outsideClick = {
          target: event.target,
          allowDeactivation: allowDeactivation
        };
      }

      return allowDeactivation;
    }
  }, {
    key: "handleDeactivate",
    value: function handleDeactivate() {
      if (this.originalOptions.onDeactivate) {
        this.originalOptions.onDeactivate.call(null); // call user's handler out of context
      }

      this.deactivateTrap();
    }
  }, {
    key: "handlePostDeactivate",
    value: function handlePostDeactivate() {
      var _this2 = this;

      var finishDeactivation = function finishDeactivation() {
        var returnFocusNode = _this2.getReturnFocusNode();

        var canReturnFocus = !!( // did the consumer allow it?
        _this2.originalOptions.returnFocusOnDeactivate && // can we actually focus the node?
        returnFocusNode !== null && returnFocusNode !== void 0 && returnFocusNode.focus && ( // was there an outside click that allowed deactivation?
        !_this2.outsideClick || // did the consumer allow deactivation when the outside node was clicked?
        _this2.outsideClick.allowDeactivation && // is the outside node NOT focusable (implying that it did NOT receive focus
        //  as a result of the click-through) -- in which case do NOT restore focus
        //  to `returnFocusNode` because focus should remain on the outside node
        !isFocusable(_this2.outsideClick.target, _this2.internalOptions.tabbableOptions)) // if no, the restore focus to `returnFocusNode` at this point
        );
        var _this2$internalOption = _this2.internalOptions.preventScroll,
            preventScroll = _this2$internalOption === void 0 ? false : _this2$internalOption;

        if (canReturnFocus) {
          // return focus to the element that had focus when the trap was activated
          returnFocusNode.focus({
            preventScroll: preventScroll
          });
        }

        if (_this2.originalOptions.onPostDeactivate) {
          _this2.originalOptions.onPostDeactivate.call(null); // don't call it in context of "this"

        }

        _this2.outsideClick = null; // reset: no longer needed
      };

      if (this.originalOptions.checkCanReturnFocus) {
        this.originalOptions.checkCanReturnFocus.call(null, this.getReturnFocusNode()) // call out of context
        .then(finishDeactivation, finishDeactivation);
      } else {
        finishDeactivation();
      }
    }
  }, {
    key: "setupFocusTrap",
    value: function setupFocusTrap() {
      if (!this.focusTrap) {
        var focusTrapElementDOMNodes = this.focusTrapElements.map( // NOTE: `findDOMNode()` does not support CSS selectors; it'll just return
        //  a new text node with the text wrapped in it instead of treating the
        //  string as a selector and resolving it to a node in the DOM
        ReactDOM.findDOMNode);
        var nodesExist = focusTrapElementDOMNodes.some(Boolean);

        if (nodesExist) {
          // eslint-disable-next-line react/prop-types -- _createFocusTrap is an internal prop
          this.focusTrap = this.props._createFocusTrap(focusTrapElementDOMNodes, this.internalOptions);

          if (this.props.active) {
            this.focusTrap.activate();
          }

          if (this.props.paused) {
            this.focusTrap.pause();
          }
        }
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.active) {
        this.setupFocusTrap();
      } // else, wait for later activation in case the `focusTrapOptions` will be updated
      //  again before the trap is activated (e.g. if waiting to know what the document
      //  object will be, so the Trap must be rendered, but the consumer is waiting to
      //  activate until they have obtained the document from a ref)
      //  @see https://github.com/focus-trap/focus-trap-react/issues/539

    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.focusTrap) {
        if (prevProps.containerElements !== this.props.containerElements) {
          this.focusTrap.updateContainerElements(this.props.containerElements);
        }

        var hasActivated = !prevProps.active && this.props.active;
        var hasDeactivated = prevProps.active && !this.props.active;
        var hasPaused = !prevProps.paused && this.props.paused;
        var hasUnpaused = prevProps.paused && !this.props.paused;

        if (hasActivated) {
          this.updatePreviousElement();
          this.focusTrap.activate();
        }

        if (hasDeactivated) {
          this.deactivateTrap();
          return; // un/pause does nothing on an inactive trap
        }

        if (hasPaused) {
          this.focusTrap.pause();
        }

        if (hasUnpaused) {
          this.focusTrap.unpause();
        }
      } else {
        // NOTE: if we're in `componentDidUpdate` and we don't have a trap yet,
        //  it either means it shouldn't be active, or it should be but none of
        //  of given `containerElements` were present in the DOM the last time
        //  we tried to create the trap
        if (prevProps.containerElements !== this.props.containerElements) {
          this.focusTrapElements = this.props.containerElements;
        } // don't create the trap unless it should be active in case the consumer
        //  is still updating `focusTrapOptions`
        //  @see https://github.com/focus-trap/focus-trap-react/issues/539


        if (this.props.active) {
          this.updatePreviousElement();
          this.setupFocusTrap();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.deactivateTrap();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var child = this.props.children ? React.Children.only(this.props.children) : undefined;

      if (child) {
        if (child.type && child.type === React.Fragment) {
          throw new Error('A focus-trap cannot use a Fragment as its child container. Try replacing it with a <div> element.');
        }

        var composedRefCallback = function composedRefCallback(element) {
          var containerElements = _this3.props.containerElements;

          if (child) {
            if (typeof child.ref === 'function') {
              child.ref(element);
            } else if (child.ref) {
              child.ref.current = element;
            }
          }

          _this3.focusTrapElements = containerElements ? containerElements : [element];
        };

        var childWithRef = React.cloneElement(child, {
          ref: composedRefCallback
        });
        return childWithRef;
      }

      return null;
    }
  }]);

  return FocusTrap;
}(React.Component); // support server-side rendering where `Element` will not be defined


var ElementType = typeof Element === 'undefined' ? Function : Element;
FocusTrap.propTypes = {
  active: PropTypes.bool,
  paused: PropTypes.bool,
  focusTrapOptions: PropTypes.shape({
    document: PropTypes.object,
    onActivate: PropTypes.func,
    onPostActivate: PropTypes.func,
    checkCanFocusTrap: PropTypes.func,
    onDeactivate: PropTypes.func,
    onPostDeactivate: PropTypes.func,
    checkCanReturnFocus: PropTypes.func,
    initialFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.func, PropTypes.bool]),
    fallbackFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.func]),
    escapeDeactivates: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    clickOutsideDeactivates: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    returnFocusOnDeactivate: PropTypes.bool,
    setReturnFocus: PropTypes.oneOfType([PropTypes.instanceOf(ElementType), PropTypes.string, PropTypes.func]),
    allowOutsideClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    preventScroll: PropTypes.bool,
    tabbableOptions: PropTypes.shape({
      displayCheck: PropTypes.oneOf(['full', 'non-zero-area', 'none']),
      getShadowRoot: PropTypes.oneOfType([PropTypes.bool, PropTypes.func])
    })
  }),
  containerElements: PropTypes.arrayOf(PropTypes.instanceOf(ElementType)),
  children: PropTypes.oneOfType([PropTypes.element, // React element
  PropTypes.instanceOf(ElementType) // DOM element
  ]) // NOTE: _createFocusTrap is internal, for testing purposes only, so we don't
  //  specify it here. It's expected to be set to the function returned from
  //  require('focus-trap'), or one with a compatible interface.

};
FocusTrap.defaultProps = {
  active: true,
  paused: false,
  focusTrapOptions: {},
  _createFocusTrap: createFocusTrap
};
var focusTrapReact = FocusTrap;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$f = "@keyframes index-module_fadeInOverlay__zZM8N {\n  0% {\n    opacity: 0;\n    visibility: visible;\n  }\n  100% {\n    opacity: 0.3;\n    visibility: visible;\n  }\n}\n@keyframes index-module_fadeOutOverlay__P3Ggk {\n  0% {\n    opacity: 0.3;\n    visibility: visible;\n  }\n  100% {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n@keyframes index-module_fadeInContainer__GcAuy {\n  0% {\n    opacity: 0;\n    visibility: visible;\n  }\n  100% {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n@keyframes index-module_fadeOutContainer__40pwN {\n  0% {\n    opacity: 1;\n    visibility: visible;\n  }\n  100% {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n@keyframes index-module_enterFromTop__AtqFs {\n  0% {\n    transform: translateY(-var(--spacing48));\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n@keyframes index-module_exitToTop__zV4-B {\n  0% {\n    transform: translateY(0px);\n  }\n  100% {\n    transform: translateY(-var(--spacing48));\n  }\n}\n@keyframes index-module_enterFromBottom__0iNKk {\n  0% {\n    transform: translateY(48px);\n  }\n  100% {\n    transform: translateY(0px);\n  }\n}\n@keyframes index-module_exitToBottom__-Ni-Z {\n  0% {\n    transform: translateY(0px);\n  }\n  100% {\n    transform: translateY(48px);\n  }\n}\n.index-module_hidden__j7KIX {\n  display: none;\n}\n.index-module_wrapper__8-K5f {\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  position: fixed;\n  right: 0;\n  top: 0;\n  visibility: hidden;\n  width: 100%;\n  z-index: 2500;\n}\n.index-module_overlayFadeIn__UG9fn {\n  align-items: center;\n  background-color: #333333;\n  display: flex;\n  height: 100%;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 100;\n  animation: index-module_fadeInOverlay__zZM8N;\n  animation-duration: 500ms;\n  animation-fill-mode: forwards;\n  animation-timing-function: cubic-bezier(0.1, 0.9, 0.2, 1);\n}\n.index-module_overlayFadeOut__vwc95 {\n  align-items: center;\n  background-color: #333333;\n  display: flex;\n  height: 100%;\n  left: 0;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  z-index: 100;\n  animation: index-module_fadeOutOverlay__P3Ggk;\n  animation-duration: 300ms;\n  animation-fill-mode: forwards;\n  animation-timing-function: cubic-bezier(0.4, 0, 1, 1);\n}\n.index-module_containerFadeInDown__Q8j2A {\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  min-height: 20vh;\n  opacity: 0;\n  position: relative;\n  z-index: 200;\n  animation-name: index-module_fadeInContainer__GcAuy, index-module_enterFromTop__AtqFs;\n  animation-duration: 500ms;\n  animation-fill-mode: forwards;\n  animation-timing-function: cubic-bezier(0.1, 0.9, 0.2, 1);\n}\n.index-module_containerFadeOutDown__--eQr {\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  min-height: 20vh;\n  opacity: 0;\n  position: relative;\n  z-index: 200;\n  animation-name: index-module_fadeOutContainer__40pwN, index-module_exitToTop__zV4-B;\n  animation-duration: 500ms;\n  animation-fill-mode: forwards;\n  animation-timing-function: cubic-bezier(0.4, 0, 1, 1);\n}\n.index-module_containerFadeInUp__LFMzM {\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  min-height: 20vh;\n  opacity: 0;\n  position: relative;\n  z-index: 200;\n  animation-name: index-module_fadeInContainer__GcAuy, index-module_enterFromBottom__0iNKk;\n  animation-duration: 500ms;\n  animation-fill-mode: forwards;\n  animation-timing-function: cubic-bezier(0.1, 0.9, 0.2, 1);\n}\n.index-module_containerFadeOutUp__r56RH {\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);\n  display: flex;\n  flex-direction: column;\n  min-height: 20vh;\n  opacity: 0;\n  position: relative;\n  z-index: 200;\n  animation-name: index-module_fadeOutContainer__40pwN, index-module_exitToBottom__-Ni-Z;\n  animation-duration: 500ms;\n  animation-fill-mode: forwards;\n  animation-timing-function: cubic-bezier(0.4, 0, 1, 1);\n}\n.index-module_containerRegular__Ktavb {\n  max-height: 60%;\n  max-width: 343px;\n  overflow: hidden auto;\n}\n.index-module_containerLarge__VcZvL {\n  max-height: 90%;\n  max-width: 100%;\n  overflow: hidden auto;\n}\n.index-module_containerFullscreen__E85qZ {\n  width: 100%;\n  height: 100%;\n  border-radius: 0;\n  overflow: hidden auto;\n  position: fixed;\n  top: 0;\n}\n.index-module_containerBottomUpFullscreen__fJW-r {\n  width: 100%;\n  max-height: calc(100dvh - 16px);\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n  overflow: hidden auto;\n  position: fixed;\n  bottom: 0;\n}\n.index-module_containerRegular__Ktavb .index-module_headerContainer__GlY4W,\n.index-module_containerRegular__Ktavb .index-module_footerContainer__gcipI,\n.index-module_containerRegular__Ktavb .index-module_content__oFIAM {\n  padding-left: 40px;\n  padding-right: 40px;\n}\n.index-module_containerLarge__VcZvL .index-module_headerContainer__GlY4W,\n.index-module_containerLarge__VcZvL .index-module_footerContainer__gcipI,\n.index-module_containerLarge__VcZvL .index-module_content__oFIAM {\n  padding-left: 40px;\n  padding-right: 40px;\n}\n.index-module_overflowScroll__5v9Wr {\n  overflow: hidden auto;\n}\n.index-module_containerFullscreen__E85qZ .index-module_headerContainer__GlY4W,\n.index-module_containerFullscreen__E85qZ .index-module_footerContainer__gcipI,\n.index-module_containerFullscreen__E85qZ .index-module_content__oFIAM {\n  padding-left: 64px;\n  padding-right: 64px;\n}\n.index-module_overflowScroll__5v9Wr {\n  overflow: hidden auto;\n}\n.index-module_content__oFIAM {\n  align-items: center;\n  display: inline-block;\n  justify-content: center;\n  word-wrap: break-word;\n}\n.index-module_headerContainer__GlY4W {\n  align-items: center;\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding-bottom: 20px;\n  padding-top: 20px;\n}\n.index-module_footerContainer__gcipI {\n  background-color: #ffffff;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  padding-bottom: 40px;\n  padding-top: 24px;\n}\n.index-module_headerContainerFixed__e0T5G {\n  border-bottom: 1px solid #e7e7e7;\n  padding-bottom: 10px;\n  padding-top: 10px;\n  position: sticky;\n  top: 0;\n}\n.index-module_footerContainerFixed__XKxpw {\n  border-top: 1px solid #e7e7e7;\n  bottom: 0;\n  padding-top: 24px;\n  position: sticky;\n}\n@media (min-width: 769px) {\n  .index-module_containerRegular__Ktavb {\n    max-width: 522px;\n  }\n\n  .index-module_containerLarge__VcZvL {\n    max-width: 522px;\n  }\n\n  .index-module_headerContainer__GlY4W,\n.index-module_footerContainer__gcipI,\n.index-module_content__oFIAM {\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n}\n@media (min-width: 1023px) {\n  .index-module_containerRegular__Ktavb {\n    max-width: 666px;\n  }\n\n  .index-module_containerLarge__VcZvL {\n    max-width: 666px;\n  }\n\n  .index-module_headerContainer__GlY4W,\n.index-module_footerContainer__gcipI,\n.index-module_content__oFIAM {\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n}\n@media (min-width: 1440px) {\n  .index-module_containerRegular__Ktavb {\n    max-width: 644px;\n  }\n\n  .index-module_containerLarge__VcZvL {\n    max-width: 866px;\n  }\n\n  .index-module_headerContainer__GlY4W,\n.index-module_footerContainer__gcipI,\n.index-module_content__oFIAM {\n    padding-left: 40px;\n    padding-right: 40px;\n  }\n}";
var styles$2 = {"hidden":"index-module_hidden__j7KIX","wrapper":"index-module_wrapper__8-K5f","overlayFadeIn":"index-module_overlayFadeIn__UG9fn","fadeInOverlay":"index-module_fadeInOverlay__zZM8N","overlayFadeOut":"index-module_overlayFadeOut__vwc95","fadeOutOverlay":"index-module_fadeOutOverlay__P3Ggk","containerFadeInDown":"index-module_containerFadeInDown__Q8j2A","fadeInContainer":"index-module_fadeInContainer__GcAuy","enterFromTop":"index-module_enterFromTop__AtqFs","containerFadeOutDown":"index-module_containerFadeOutDown__--eQr","fadeOutContainer":"index-module_fadeOutContainer__40pwN","exitToTop":"index-module_exitToTop__zV4-B","containerFadeInUp":"index-module_containerFadeInUp__LFMzM","enterFromBottom":"index-module_enterFromBottom__0iNKk","containerFadeOutUp":"index-module_containerFadeOutUp__r56RH","exitToBottom":"index-module_exitToBottom__-Ni-Z","containerRegular":"index-module_containerRegular__Ktavb","containerLarge":"index-module_containerLarge__VcZvL","containerFullscreen":"index-module_containerFullscreen__E85qZ","containerBottomUpFullscreen":"index-module_containerBottomUpFullscreen__fJW-r","headerContainer":"index-module_headerContainer__GlY4W","footerContainer":"index-module_footerContainer__gcipI","content":"index-module_content__oFIAM","overflowScroll":"index-module_overflowScroll__5v9Wr","headerContainerFixed":"index-module_headerContainerFixed__e0T5G","footerContainerFixed":"index-module_footerContainerFixed__XKxpw"};
styleInject(css_248z$f,{"insertAt":"top"});

const ModalContext = React__default.createContext({});

const Content = ({ children, className }) => {
    const { fixHeader, fixFooter } = React__default.useContext(ModalContext);
    const contentStyle = getContentStyle(className, fixHeader, fixFooter);
    return React__default.createElement("div", { className: contentStyle }, children);
};
const getContentStyle = (className, fixHeader, fixFooter) => classnames(className, styles$2.content, {
    [styles$2.overflowScroll]: fixHeader || fixFooter,
});

const Footer = ({ children, className, fixed }) => {
    const { setFixFooter } = React__default.useContext(ModalContext);
    useEffect(() => {
        setFixFooter && setFixFooter(fixed);
    });
    const footerContainerClassName = getFooterContainerStyles(className, fixed);
    return React__default.createElement("div", { className: footerContainerClassName }, children);
};
const getFooterContainerStyles = (className, fixed) => classnames(className, styles$2.footerContainer, {
    [styles$2.footerContainerFixed]: fixed,
});

var css_248z$e = ".button-module_button__RiZd- {\n  align-items: center;\n  border-radius: 2px;\n  cursor: pointer;\n  display: flex;\n  font-family: benton-sans, sans-serif;\n  font-weight: 500;\n  font-size: 14px;\n  justify-content: center;\n  letter-spacing: 0.25px;\n  overflow: hidden;\n  padding: 8px;\n  width: 100%;\n}\n.button-module_button__RiZd-:focus {\n  outline-color: #317aad;\n  outline-offset: 1px;\n  outline-style: auto;\n  outline-width: 2px;\n}\n.button-module_button__RiZd-:disabled {\n  cursor: default;\n  opacity: 0.2;\n}\n.button-module_buttonLarge__dZdJ6 {\n\n  height: 48px;\n  min-width: 134px;\n}\n.button-module_buttonLargeIcon__5xUfs {\n\n  height: 48px;\n  padding: 0px;\n  width: 48px;\n}\n.button-module_buttonRegular__6-2hG {\n\n  height: 40px;\n  min-width: 102px;\n}\n.button-module_buttonRegularIcon__DTRqn {\n\n  height: 40px;\n  padding: 0px;\n  width: 40px;\n}\n.button-module_buttonSmall__4v4PR {\n\n  height: 32px;\n  min-width: 70px;\n}\n.button-module_buttonSmallIcon__NrRV0 {\n\n  height: 32px;\n  padding: 0px;\n  width: 32px;\n}\n.button-module_buttonPrimary__tlsxX {\n  border-style: solid;\n  border-width: 1px;\n}\n.button-module_buttonPrimaryNavy__gutLQ {\n  background: #00253e;\n\n  border-color: #00253e;\n  color: #ffffff;\n}\n.button-module_buttonPrimaryNavy__gutLQ:hover:enabled {\n  background: #23448d;\n  border-color: #23448d;\n}\n.button-module_buttonPrimaryNavy__gutLQ:active:enabled {\n  background: #06235f;\n  border-color: #06235f;\n}\n.button-module_buttonPrimaryNavyActive__j-gy- {\n  background: #06235f;\n  border-color: #06235f;\n}\n.button-module_buttonPrimaryGold__H33XD {\n  background: #c29b40;\n\n  border-color: #c29b40;\n  color: #00253e;\n}\n.button-module_buttonPrimaryGold__H33XD:hover:enabled {\n  background: #a68940;\n  border-color: #a68940;\n}\n.button-module_buttonPrimaryGold__H33XD:active:enabled {\n  background: #c29b40;\n  border-color: #c29b40;\n}\n.button-module_buttonPrimaryGoldActive__f-RQl {\n  background: #c29b40;\n  border-color: #c29b40;\n}\n.button-module_buttonPrimaryDanger__fltR6 {\n  background: #dd2415;\n\n  border-color: #dd2415;\n  color: #ffffff;\n}\n.button-module_buttonPrimaryDanger__fltR6:hover:enabled {\n  background: #a81e13;\n  border-color: #a81e13;\n}\n.button-module_buttonPrimaryDanger__fltR6:active:enabled {\n  background: #dd2415;\n  border-color: #dd2415;\n}\n.button-module_buttonPrimaryDangerActive__ASUin {\n  background: #dd2415;\n  border-color: #dd2415;\n}\n.button-module_buttonSecondary__Svb9S {\n  background: transparent;\n  border: 1px solid #cecece;\n  color: #00253e;\n}\n.button-module_buttonSecondary__Svb9S:hover:enabled {\n  border-color: #23448d;\n  color: #23448d;\n}\n.button-module_buttonSecondary__Svb9S:active:enabled {\n  border-color: #00253e;\n  color: #00253e;\n}\n.button-module_buttonSecondaryActive__f4cwx {\n  border-color: #00253e;\n  color: #00253e;\n}\n.button-module_buttonTertiary__ApQ-M {\n  background: transparent;\n  border: none;\n  color: #00253e;\n}\n.button-module_buttonTertiary__ApQ-M:hover:enabled {\n  background: #f1f1f1;\n  color: #23448d;\n}\n.button-module_buttonTertiary__ApQ-M:active:enabled {\n  background: transparent;\n  color: #00253e;\n}\n.button-module_buttonTertiaryActive__kF22A {\n  background: transparent;\n  color: #00253e;\n}\n";
var styles$1 = {"button":"button-module_button__RiZd-","buttonLarge":"button-module_buttonLarge__dZdJ6 button-module_button__RiZd-","buttonLargeIcon":"button-module_buttonLargeIcon__5xUfs button-module_button__RiZd-","buttonRegular":"button-module_buttonRegular__6-2hG button-module_button__RiZd-","buttonRegularIcon":"button-module_buttonRegularIcon__DTRqn button-module_button__RiZd-","buttonSmall":"button-module_buttonSmall__4v4PR button-module_button__RiZd-","buttonSmallIcon":"button-module_buttonSmallIcon__NrRV0 button-module_button__RiZd-","buttonPrimary":"button-module_buttonPrimary__tlsxX","buttonPrimaryNavy":"button-module_buttonPrimaryNavy__gutLQ button-module_buttonPrimary__tlsxX","buttonPrimaryNavyActive":"button-module_buttonPrimaryNavyActive__j-gy-","buttonPrimaryGold":"button-module_buttonPrimaryGold__H33XD button-module_buttonPrimary__tlsxX","buttonPrimaryGoldActive":"button-module_buttonPrimaryGoldActive__f-RQl","buttonPrimaryDanger":"button-module_buttonPrimaryDanger__fltR6 button-module_buttonPrimary__tlsxX","buttonPrimaryDangerActive":"button-module_buttonPrimaryDangerActive__ASUin","buttonSecondary":"button-module_buttonSecondary__Svb9S","buttonSecondaryActive":"button-module_buttonSecondaryActive__f4cwx","buttonTertiary":"button-module_buttonTertiary__ApQ-M","buttonTertiaryActive":"button-module_buttonTertiaryActive__kF22A"};
styleInject(css_248z$e,{"insertAt":"top"});

var css_248z$d = "@keyframes IconLoading-module_spin__8T1oe {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(359deg);\n  }\n}\n.IconLoading-module_loading__tVp1l {\n  animation: IconLoading-module_spin__8T1oe 2s linear infinite;\n}\n";
var styles = {"loading":"IconLoading-module_loading__tVp1l","spin":"IconLoading-module_spin__8T1oe"};
styleInject(css_248z$d,{"insertAt":"top"});

const IconLoading = () => (React__default.createElement("svg", { className: styles.loading, width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React__default.createElement("path", { opacity: "0.2", d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12Z", fill: "currentColor" }),
    React__default.createElement("path", { d: "M6.12215 20.0902C4.75945 19.1001 3.66891 17.7819 2.95173 16.2578C2.23455 14.7337 1.91397 13.0532 2.01973 11.3721L4.01579 11.4977C3.93118 12.8425 4.18764 14.187 4.76138 15.4062C5.33513 16.6255 6.20756 17.6801 7.29772 18.4721L6.12215 20.0902Z", fill: "currentColor" })));

const Button = ({ id, className, buttonStyle = 'primaryNavy', size = 'large', type = 'button', disabled = false, loading = false, active = false, onClick, children, ...rest }) => {
    const buttonClassName = classnames(className, {
        [getButtonSizeClassName(size)]: true,
        [getButtonStyleClassName(buttonStyle)]: true,
        [getButtonActiveClassName(buttonStyle)]: active,
    });
    return (React__default.createElement("button", { id: id, type: type, onClick: !loading && !disabled ? onClick : void 0, "aria-disabled": disabled, disabled: disabled, className: buttonClassName, ...rest }, loading ? React__default.createElement(IconLoading, null) : children));
};
const getButtonSizeClassName = (b) => {
    switch (b) {
        case 'large':
            return styles$1.buttonLarge;
        case 'regular':
            return styles$1.buttonRegular;
        case 'small':
            return styles$1.buttonSmall;
        case 'largeIcon':
            return styles$1.buttonLargeIcon;
        case 'regularIcon':
            return styles$1.buttonRegularIcon;
        case 'smallIcon':
            return styles$1.buttonSmallIcon;
    }
};
const getButtonStyleClassName = (b) => {
    switch (b) {
        case 'primaryNavy':
            return styles$1.buttonPrimaryNavy;
        case 'primaryGold':
            return styles$1.buttonPrimaryGold;
        case 'primaryDanger':
            return styles$1.buttonPrimaryDanger;
        case 'tertiary':
            return styles$1.buttonTertiary;
        case 'secondary':
            return styles$1.buttonSecondary;
    }
};
const getButtonActiveClassName = (b) => {
    switch (b) {
        case 'primaryNavy':
            return styles$1.buttonPrimaryNavyActive;
        case 'primaryGold':
            return styles$1.buttonPrimaryGoldActive;
        case 'primaryDanger':
            return styles$1.buttonPrimaryDangerActive;
        case 'tertiary':
            return styles$1.buttonTertiaryActive;
        case 'secondary':
            return styles$1.buttonSecondaryActive;
    }
};

/* This file is generated, changes will get overwritten */
const SvgCloseRegular24 = (props) => (React$1.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor", "aria-label": "Close", viewBox: "0 0 24 24", ...props },
    React$1.createElement("path", { fillRule: "evenodd", d: "M5.242 4.213a.727.727 0 0 0-1.029 1.029L10.972 12l-6.759 6.759a.727.727 0 1 0 1.029 1.028L12 13.029l6.759 6.758a.727.727 0 0 0 1.028-1.028L13.029 12l6.758-6.758a.727.727 0 0 0-1.028-1.029L12 10.972z", clipRule: "evenodd" })));

var css_248z$c = ".headline-module_headline64Regular__7Df-e {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 4rem;\n  font-weight: 325;\n  letter-spacing: 0;\n  line-height: 4.5rem;\n}\n.headline-module_headline48Regular__oAvHN {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 3rem;\n  font-weight: 325;\n  letter-spacing: 0;\n  line-height: 3.5rem;\n}\n.headline-module_headline32Regular__pMgbY {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 2rem;\n  font-weight: 325;\n  letter-spacing: 0;\n  line-height: 2.5rem;\n}\n.headline-module_headline28Regular__CWxFH {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 1.75rem;\n  font-weight: 325;\n  letter-spacing: 0;\n  line-height: 2rem;\n}\n.headline-module_headline24Regular__FNS1U {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 1.5rem;\n  font-weight: 325;\n  letter-spacing: 0;\n  line-height: 1.75rem;\n}\n.headline-module_headline20Regular__zmXrx {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 1.25rem;\n  font-weight: 325;\n  letter-spacing: 0.015625rem;\n  line-height: 1.5rem;\n}\n.headline-module_headline4Xs__xmk2e {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 0.688rem;\n  font-weight: 325;\n  letter-spacing: 0.015625rem;\n  line-height: 0.813rem;\n}\n.headline-module_headline3Xs__OMSBF {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 0.875rem;\n  font-weight: 325;\n  letter-spacing: 0.015625rem;\n  line-height: 1rem;\n}\n.headline-module_headline2Xs__P-I3U {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 1rem;\n  font-weight: 325;\n  letter-spacing: 0.015625rem;\n  line-height: 1.125rem;\n}\n.headline-module_headlineXs__zZp1b {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 1.25rem;\n  font-weight: 325;\n  letter-spacing: 0.015625rem;\n  line-height: 1.5rem;\n}\n.headline-module_headlineS__8HI9w {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 1.5rem;\n  font-weight: 325;\n  letter-spacing: 0;\n  line-height: 1.75rem;\n}\n.headline-module_headlineM__G6hlG {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 1.75rem;\n  font-weight: 325;\n  letter-spacing: 0;\n  line-height: 2rem;\n}\n.headline-module_headlineL__H1NKG {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 2rem;\n  font-weight: 325;\n  letter-spacing: 0;\n  line-height: 2.5rem;\n}\n.headline-module_headlineXl__oET4Y {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 3rem;\n  font-weight: 325;\n  letter-spacing: 0;\n  line-height: 3.5rem;\n}\n.headline-module_headline2Xl__ObcB4 {\n  font-family: Mercury Display A, Mercury Display B, MercuryDisplay-wb, Mercury Display, serif;\n  font-size: 4rem;\n  font-weight: 325;\n  letter-spacing: 0;\n  line-height: 4.5rem;\n}\n";
var style$1 = {"headline64Regular":"headline-module_headline64Regular__7Df-e","headline48Regular":"headline-module_headline48Regular__oAvHN","headline32Regular":"headline-module_headline32Regular__pMgbY","headline28Regular":"headline-module_headline28Regular__CWxFH","headline24Regular":"headline-module_headline24Regular__FNS1U","headline20Regular":"headline-module_headline20Regular__zmXrx","headline4Xs":"headline-module_headline4Xs__xmk2e","headline3Xs":"headline-module_headline3Xs__OMSBF","headline2Xs":"headline-module_headline2Xs__P-I3U","headlineXs":"headline-module_headlineXs__zZp1b","headlineS":"headline-module_headlineS__8HI9w","headlineM":"headline-module_headlineM__G6hlG","headlineL":"headline-module_headlineL__H1NKG","headlineXl":"headline-module_headlineXl__oET4Y","headline2Xl":"headline-module_headline2Xl__ObcB4"};
styleInject(css_248z$c,{"insertAt":"top"});

const HeadlineM = ({ className, hTag = 'h1', children, ...rest }) => React__default.createElement(hTag, {
    className: classnames([style$1.headlineM, className]),
    ...rest,
}, children);

var css_248z$b = ".paragraph-module_paragraph18Regular__6MLdN {\n  font-family: benton-sans, sans-serif;\n  font-size: 1.125rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.625rem;\n}\n.paragraph-module_paragraph16Regular__CXt6G {\n  font-family: benton-sans, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.5rem;\n}\n.paragraph-module_paragraph14Regular__Zfr98 {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.375rem;\n}\n.paragraph-module_paragraph12Regular__8IyUe {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.125rem;\n}\n.paragraph-module_paragraph18LinkRegular__7PpzN {\n  color: #23448d;\n  font-family: benton-sans, sans-serif;\n  font-size: 1.125rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.625rem;\n  text-decoration: None;\n}\n.paragraph-module_paragraph16LinkRegular__iSFXd {\n  color: #23448d;\n  font-family: benton-sans, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.5rem;\n  text-decoration: None;\n}\n.paragraph-module_paragraph14LinkRegular__3Rpqs {\n  color: #23448d;\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.375rem;\n  text-decoration: None;\n}\n.paragraph-module_paragraph12LinkRegular__xzWxh {\n  color: #23448d;\n  font-family: benton-sans, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.125rem;\n  text-decoration: None;\n}\n.paragraph-module_paragraph18LinkRegular__7PpzN:hover {\n  text-decoration: underline;\n}\n.paragraph-module_paragraph16LinkRegular__iSFXd:hover {\n  text-decoration: underline;\n}\n.paragraph-module_paragraph14LinkRegular__3Rpqs:hover {\n  text-decoration: underline;\n}\n.paragraph-module_paragraph12LinkRegular__xzWxh:hover {\n  text-decoration: underline;\n}\n.paragraph-module_paragraphXl__-R0i0 {\n  font-family: benton-sans, sans-serif;\n  font-size: 1.5rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.75rem;\n}\n.paragraph-module_paragraphL__HBkei {\n  font-family: benton-sans, sans-serif;\n  font-size: 1.125rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.625rem;\n}\n.paragraph-module_paragraphM__HZ9Yg {\n  font-family: benton-sans, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.5rem;\n}\n.paragraph-module_paragraphS__qcmAM {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.375rem;\n}\n.paragraph-module_paragraphXs__AR52k {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.125rem;\n}\n.paragraph-module_paragraph2Xs__PpiuW {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.625rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 0.938rem;\n}\n.paragraph-module_paragraph3Xs__1eift {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.5rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 0.75rem;\n}\n";
var style = {"paragraph18Regular":"paragraph-module_paragraph18Regular__6MLdN","paragraph16Regular":"paragraph-module_paragraph16Regular__CXt6G","paragraph14Regular":"paragraph-module_paragraph14Regular__Zfr98","paragraph12Regular":"paragraph-module_paragraph12Regular__8IyUe","paragraph18LinkRegular":"paragraph-module_paragraph18LinkRegular__7PpzN","paragraph16LinkRegular":"paragraph-module_paragraph16LinkRegular__iSFXd","paragraph14LinkRegular":"paragraph-module_paragraph14LinkRegular__3Rpqs","paragraph12LinkRegular":"paragraph-module_paragraph12LinkRegular__xzWxh","paragraphXl":"paragraph-module_paragraphXl__-R0i0","paragraphL":"paragraph-module_paragraphL__HBkei","paragraphM":"paragraph-module_paragraphM__HZ9Yg","paragraphS":"paragraph-module_paragraphS__qcmAM","paragraphXs":"paragraph-module_paragraphXs__AR52k","paragraph2Xs":"paragraph-module_paragraph2Xs__PpiuW","paragraph3Xs":"paragraph-module_paragraph3Xs__1eift"};
styleInject(css_248z$b,{"insertAt":"top"});

React__default.forwardRef(function forwardRef({ className, id, children, href, ...rest }, ref) {
    return (React__default.createElement("a", { id: id, className: classnames([style.paragraph18LinkRegular, className]), ref: ref, href: href, ...rest }, children));
});

React__default.forwardRef(function forwardRef({ className, children, id, href, ...rest }, ref) {
    return (React__default.createElement("a", { id: id, className: classnames([style.paragraph16LinkRegular, className]), ref: ref, href: href, ...rest }, children));
});

React__default.forwardRef(function forwardRef({ className, children, id, href, ...rest }, ref) {
    return (React__default.createElement("a", { id: id, className: classnames([style.paragraph14LinkRegular, className]), ref: ref, href: href, ...rest }, children));
});

React__default.forwardRef(function forwardRef({ className, children, id, href, ...rest }, ref) {
    return (React__default.createElement("a", { id: id, className: classnames([style.paragraph12LinkRegular, className]), ref: ref, href: href, ...rest }, children));
});

var css_248z$a = ".buttonLink-module_buttonLink__kAnvq {\n  cursor: pointer;\n  text-decoration: None;\n}\n.buttonLink-module_buttonLink__kAnvq:focus-visible {\n  outline-color: #317aad;\n  outline-offset: 1px;\n  outline-style: auto;\n  outline-width: 2px;\n}\n.buttonLink-module_buttonLink12Regular__m-6OY {\n  color: #23448d;\n  font-family: benton-sans, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.125rem;\n}\n.buttonLink-module_buttonLink12Regular__m-6OY:hover {\n  text-decoration: underline;\n}\n.buttonLink-module_buttonLink14Regular__HC3EU {\n  color: #23448d;\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.375rem;\n}\n.buttonLink-module_buttonLink14Regular__HC3EU:hover {\n  text-decoration: underline;\n}\n.buttonLink-module_buttonLink16Regular__6v2fC {\n  color: #23448d;\n  font-family: benton-sans, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.5rem;\n}\n.buttonLink-module_buttonLink16Regular__6v2fC:hover {\n  text-decoration: underline;\n}\n.buttonLink-module_buttonLink18Regular__kiVl8 {\n  color: #23448d;\n  font-family: benton-sans, sans-serif;\n  font-size: 1.125rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.625rem;\n}\n.buttonLink-module_buttonLink18Regular__kiVl8:hover {\n  text-decoration: underline;\n}\n";
styleInject(css_248z$a,{"insertAt":"top"});

var css_248z$9 = ".label-module_label20Medium__Rf-Z8 {\n  font-family: benton-sans, sans-serif;\n  font-size: 1.25rem;\n  font-weight: 500;\n  letter-spacing: 0.015625rem;\n  line-height: 1.625rem;\n}\n.label-module_label18Medium__LZmdm {\n  font-family: benton-sans, sans-serif;\n  font-size: 1.125rem;\n  font-weight: 500;\n  letter-spacing: 0.015625rem;\n  line-height: 1.625rem;\n}\n.label-module_label16Medium__Z4VRX {\n  font-family: benton-sans, sans-serif;\n  font-size: 1rem;\n  font-weight: 500;\n  letter-spacing: 0rem;\n  line-height: 1.5rem;\n}\n.label-module_label14Medium__uD9e- {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 500;\n  letter-spacing: 0rem;\n  line-height: 1.375rem;\n}\n.label-module_label12Medium__THkRn {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 500;\n  letter-spacing: 0rem;\n  line-height: 1.125rem;\n}\n";
styleInject(css_248z$9,{"insertAt":"top"});

var css_248z$8 = ".subhead-module_subheadXs__CCDnm {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0rem;\n  line-height: 1.125rem;\n}\n.subhead-module_subheadS__I82YK {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 700;\n  letter-spacing: 0rem;\n  line-height: 1.375rem;\n}\n.subhead-module_subheadM__8x5KF {\n  font-family: benton-sans, sans-serif;\n  font-size: 1rem;\n  font-weight: 700;\n  letter-spacing: 0rem;\n  line-height: 1.5rem;\n}\n.subhead-module_subheadL__Za2-Z {\n  font-family: benton-sans, sans-serif;\n  font-size: 1.125rem;\n  font-weight: 700;\n  letter-spacing: 0rem;\n  line-height: 1.625rem;\n}\n.subhead-module_subheadXl__C5wRC {\n  font-family: benton-sans, sans-serif;\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: 0rem;\n  line-height: 1.75rem;\n}\n";
styleInject(css_248z$8,{"insertAt":"top"});

var css_248z$7 = ".caps-module_caps14Medium__xWPsh {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 500;\n  letter-spacing: 0.015625rem;\n  line-height: 1.375rem;\n  text-transform: uppercase;\n}\n.caps-module_caps12Medium__GhMuf {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 500;\n  letter-spacing: 0.015625rem;\n  line-height: 1.125rem;\n  text-transform: uppercase;\n}\n";
styleInject(css_248z$7,{"insertAt":"top"});

var css_248z$6 = ".caption-module_captionM__TEL-B {\n  font-family: benton-sans, sans-serif;\n  font-size: 1rem;\n  font-weight: 350;\n  letter-spacing: 0.015625rem;\n  line-height: 1.5rem;\n  color: #6b6b6b;\n}\n.caption-module_captionS__aurdZ {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 350;\n  letter-spacing: 0.015625rem;\n  line-height: 1.375rem;\n  color: #6b6b6b;\n}\n.caption-module_captionXs__UbVnT {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 350;\n  letter-spacing: 0.015625rem;\n  line-height: 1.125rem;\n  color: #6b6b6b;\n}\n";
styleInject(css_248z$6,{"insertAt":"top"});

var css_248z$5 = ".link-module_link__W-7kV {\n  cursor: pointer;\n  text-decoration: None;\n}\n.link-module_link__W-7kV:focus-visible {\n  outline-color: #317aad;\n  outline-offset: 1px;\n  outline-style: auto;\n  outline-width: 2px;\n}\n.link-module_linkXs__wpEAz {\n  color: #23448d;\n  font-family: benton-sans, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.125rem;\n}\n.link-module_linkXs__wpEAz:hover {\n  text-decoration: underline;\n}\n.link-module_linkS__faWqE {\n  color: #23448d;\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.375rem;\n}\n.link-module_linkS__faWqE:hover {\n  text-decoration: underline;\n}\n.link-module_linkM__EvMoZ {\n  color: #23448d;\n  font-family: benton-sans, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.5rem;\n}\n.link-module_linkM__EvMoZ:hover {\n  text-decoration: underline;\n}\n.link-module_linkL__GS5l1 {\n  color: #23448d;\n  font-family: benton-sans, sans-serif;\n  font-size: 1.125rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.625rem;\n}\n.link-module_linkL__GS5l1:hover {\n  text-decoration: underline;\n}\n";
styleInject(css_248z$5,{"insertAt":"top"});

var css_248z$4 = ".button-module_button14Medium__fh7fw {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 500;\n  letter-spacing: 0.015625rem;\n  line-height: 1.25rem;\n}\n.button-module_buttonM__fU8qv {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 500;\n  letter-spacing: 0.015625rem;\n  line-height: 1.25rem;\n}\n";
styleInject(css_248z$4,{"insertAt":"top"});

var css_248z$3 = ".monospace-module_monospace16Regular__Wwnnb {\n  font-family: mulish, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.5rem;\n}\n.monospace-module_monospace14Regular__kmlmQ {\n  font-family: mulish, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.25rem;\n}\n.monospace-module_monospace12Regular__-Ikkf {\n  font-family: mulish, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1rem;\n}\n.monospace-module_monospaceM__WhPY8 {\n  font-family: mulish, sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.5rem;\n}\n.monospace-module_monospaceS__aaWeB {\n  font-family: mulish, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1.25rem;\n}\n.monospace-module_monospaceXs__19rt- {\n  font-family: mulish, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 400;\n  letter-spacing: 0;\n  line-height: 1rem;\n}\n";
styleInject(css_248z$3,{"insertAt":"top"});

var css_248z$2 = ".product-module_product64Medium__WuIod {\n  font-family: benton-sans, sans-serif;\n  font-size: 4rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 4.5rem;\n}\n.product-module_product48Medium__Noy51 {\n  font-family: benton-sans, sans-serif;\n  font-size: 3rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 3.5rem;\n}\n.product-module_product40Medium__M3R5D {\n  font-family: benton-sans, sans-serif;\n  font-size: 2.5rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 3rem;\n}\n.product-module_product32Medium__8no96 {\n  font-family: benton-sans, sans-serif;\n  font-size: 2rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 2.5rem;\n}\n";
styleInject(css_248z$2,{"insertAt":"top"});

var css_248z$1 = ".selection-module_selection3Xs__f5jDB {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.5rem;\n  font-weight: 600;\n  letter-spacing: 0rem;\n  line-height: 0.75rem;\n}\n.selection-module_selection2Xs__5WFTv {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.625rem;\n  font-weight: 600;\n  letter-spacing: 0rem;\n  line-height: 0.938rem;\n}\n.selection-module_selectionXs__f1pN1 {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0rem;\n  line-height: 1.125rem;\n}\n.selection-module_selectionS__xSA5V {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 600;\n  letter-spacing: 0rem;\n  line-height: 1.375rem;\n}\n.selection-module_selectionM__2vOIv {\n  font-family: benton-sans, sans-serif;\n  font-size: 1rem;\n  font-weight: 600;\n  letter-spacing: 0rem;\n  line-height: 1.5rem;\n}\n.selection-module_selectionL__CB6wm {\n  font-family: benton-sans, sans-serif;\n  font-size: 1.125rem;\n  font-weight: 600;\n  letter-spacing: 0rem;\n  line-height: 1.625rem;\n}\n.selection-module_selectionXl__isv1z {\n  font-family: benton-sans, sans-serif;\n  font-size: 1.5rem;\n  font-weight: 600;\n  letter-spacing: 0rem;\n  line-height: 2.25rem;\n}\n";
styleInject(css_248z$1,{"insertAt":"top"});

var css_248z = ".tabular-module_subhead__w-Pb- {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0rem;\n  line-height: 1.125rem;\n  color: #6b6b6b;\n}\n.tabular-module_data__RroAS {\n  font-family: benton-sans, sans-serif;\n  font-size: 0.875rem;\n  font-weight: 400;\n  letter-spacing: 0rem;\n  line-height: 1.375rem;\n  color: #292929;\n}\n";
styleInject(css_248z,{"insertAt":"top"});

const isServer = () => typeof window === 'undefined';
const useOneTrustFocus = () => {
    const [isFocusActive, setIsFocusActive] = useState(() => true);
    const OneTrustConsentAppliedEvent = 'OTConsentApplied';
    const OneTrustLoadedEvent = 'oneTrustLoaded';
    useEffect(() => {
        const setFocusOnOneTrustLoaded = () => {
            setIsFocusActive(() => {
                // check to see whether consuming application has OneTrust available in the browser window
                const isOneTrustInScope = !!window?.OneTrust;
                // check to see whether OT modal has been closed by the user or is hidden because the user has already opted into cookies
                const isOneTrustModalClosed = window?.OneTrust?.IsAlertBoxClosed() ?? false;
                return !isOneTrustInScope || isOneTrustModalClosed;
            });
        };
        const setFocus = () => setIsFocusActive(true);
        window.addEventListener(OneTrustConsentAppliedEvent, setFocus);
        window.addEventListener(OneTrustLoadedEvent, setFocusOnOneTrustLoaded);
        setFocusOnOneTrustLoaded();
        return () => {
            window.removeEventListener(OneTrustConsentAppliedEvent, setFocus);
            window.removeEventListener(OneTrustLoadedEvent, setFocusOnOneTrustLoaded);
        };
    }, []);
    return isFocusActive;
};
const useLockBodyScroll = () => {
    useEffect(() => {
        // Get original body overflow
        const originalPosition = window.getComputedStyle(document.body).position;
        const originalRight = window.getComputedStyle(document.body).right;
        const originalLeft = window.getComputedStyle(document.body).left;
        const originalTop = window.getComputedStyle(document.body).top;
        const originalMarginRight = window.getComputedStyle(document.body).marginRight;
        const originalMarginLeft = window.getComputedStyle(document.body).marginLeft;
        const originalOverflowY = window.getComputedStyle(document.body).overflowY;
        // Prevent scrolling on mount
        const topPos = window.pageYOffset;
        document.body.style.position = 'fixed';
        document.body.style.right = '0';
        document.body.style.left = '0';
        document.body.style.top = `-${topPos}px`;
        document.body.style.marginRight = 'auto';
        document.body.style.marginLeft = 'auto';
        document.body.style.overflowY = window.innerHeight < document.body.scrollHeight ? 'scroll' : originalOverflowY;
        // Re-enable scrolling when component unmounts
        return () => {
            document.body.style.position = originalPosition;
            document.body.style.right = originalRight;
            document.body.style.left = originalLeft;
            document.body.style.top = originalTop;
            document.body.style.marginRight = originalMarginRight;
            document.body.style.marginLeft = originalMarginLeft;
            document.body.style.overflowY = originalOverflowY;
            window.scrollTo({ top: topPos });
        };
    }, []); // Empty array ensures effect is only run on mount and unmount
};

const voidFunction = () => void 0;
const Header = ({ className, fixed, text }) => {
    const { onAfterClose } = React__default.useContext(ModalContext);
    const headerContainerClassName = getHeaderContainerStyles(className, fixed);
    useLockBodyScroll();
    return (React__default.createElement("div", { className: headerContainerClassName },
        React__default.createElement(HeadlineM, { id: "modal-header-title" }, text),
        React__default.createElement(Button, { buttonStyle: "tertiary", size: 'regularIcon', onClick: onAfterClose || voidFunction, "aria-label": "Close Modal" },
            React__default.createElement(SvgCloseRegular24, null))));
};
const getHeaderContainerStyles = (className, fixed) => classnames(className, styles$2.headerContainer, {
    [styles$2.headerContainerFixed]: fixed,
});

function useTimedIsOpening(value, openDelay) {
    const [isOpening, setIsOpening] = useState(false);
    useEffect(() => {
        setIsOpening(value);
        const timer = setTimeout(() => {
            setIsOpening(false);
        }, openDelay ?? 500);
        return () => {
            clearTimeout(timer);
        };
    }, [value, openDelay]);
    return isOpening;
}

const Modal = ({ children, className, wrapperClassName, headerClassName, onClose, isOpen, direction = 'down', size = 'regular', fixHeader, headerTitle, role = 'dialog', ariaDescribedby, closeOnOutsideClick = false, }) => {
    const overlayRef = useRef(null);
    const isOpening = useTimedIsOpening(isOpen, 500);
    const isFocusActive = useOneTrustFocus();
    const afterClose = useCallback(() => {
        onClose();
    }, [onClose]);
    useEffect(() => {
        const overlayRefCurrent = overlayRef.current;
        const handleOverlayMousedown = (e) => {
            if (closeOnOutsideClick && !isOpening) {
                afterClose();
            }
            else {
                e.preventDefault();
            }
        };
        overlayRefCurrent && overlayRefCurrent.addEventListener('mousedown', handleOverlayMousedown);
        return () => {
            overlayRefCurrent && overlayRefCurrent.removeEventListener('mousedown', handleOverlayMousedown);
        };
    }, [isOpening, afterClose, closeOnOutsideClick]);
    useEffect(() => {
        const handleKeyPress = (e) => {
            if (e.key === 'Escape') {
                afterClose();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleKeyPress);
        }
        return () => {
            document.removeEventListener('keydown', handleKeyPress);
        };
    }, [isOpen, afterClose]);
    const containerClassName = getContainerClasses(isOpen, size, direction, className);
    // We cannot use createPortal on the document when we're SSR
    if (isServer()) {
        return null;
    }
    return createPortal(React__default.createElement(ModalContext.Provider, { value: {
            onAfterClose: afterClose,
            fixHeader: fixHeader,
        } },
        React__default.createElement(focusTrapReact, { active: isOpen && isFocusActive },
            React__default.createElement("div", { className: classnames(wrapperClassName, styles$2.wrapper) },
                React__default.createElement("div", { role: role, "aria-labelledby": "modal-header-title", "aria-describedby": ariaDescribedby, "aria-modal": isOpen, id: "modal-container", className: containerClassName, onAnimationEnd: () => (isOpen ? {} : afterClose) },
                    headerTitle && React__default.createElement(Header, { fixed: fixHeader, text: headerTitle, className: headerClassName }),
                    children),
                React__default.createElement("div", { id: "modal-overlay", className: isOpen ? styles$2.overlayFadeIn : styles$2.overlayFadeOut, ref: overlayRef })))), document.body);
};
Modal.Footer = Footer;
Modal.Content = Content;
const getContainerClasses = (isOpen, size, direction, className) => {
    const transitionClasses = {
        [direction !== 'up' ? styles$2.containerFadeInDown : styles$2.containerFadeInUp]: isOpen,
        [direction !== 'up' ? styles$2.containerFadeOutDown : styles$2.containerFadeOutUp]: !isOpen,
    };
    switch (size) {
        case 'bottomUpFullscreen':
            return classnames(className, styles$2.containerBottomUpFullscreen, transitionClasses);
        case 'fullscreen':
            return classnames(className, styles$2.containerFullscreen, transitionClasses);
        case 'large':
            return classnames(className, styles$2.containerLarge, transitionClasses);
        default:
            return classnames(className, styles$2.containerRegular, transitionClasses);
    }
};

export { Modal };
//# sourceMappingURL=index.es.js.map
